var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChevronRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 49,
    viewBox: "0 0 56 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3778_17520)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3778_17520)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1.06641,
    width: 55,
    height: 47,
    rx: 23.5,
    stroke: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M31.125 25.7812C31.2344 25.6719 31.3164 25.5078 31.3164 25.3164C31.3164 25.1523 31.2344 24.9883 31.125 24.8516L27.4062 21.1328C27.2695 21.0234 27.1055 20.9414 26.9414 20.9414C26.75 20.9414 26.5859 21.0234 26.4766 21.1328L25.875 21.7617C25.7383 21.8984 25.6836 22.0625 25.6836 22.2266C25.6836 22.418 25.7383 22.582 25.875 22.6914L28.5 25.3164L25.875 27.9414C25.7383 28.0781 25.6836 28.2422 25.6836 28.4062C25.6836 28.5977 25.7383 28.7617 25.875 28.8711L26.4766 29.5C26.5859 29.6367 26.75 29.6914 26.9414 29.6914C27.1055 29.6914 27.2695 29.6367 27.4062 29.5L31.125 25.7812Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3778_17520"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 47.6888,
    fill: "white",
    transform: "translate(0 0.566406)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3778_17520"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 48,
    fill: "white",
    transform: "translate(0 0.566406)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron-right.d526f7392d5d4c3eef048e42ed818d7a.svg";
export { ForwardRef as ReactComponent };